import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import tdsIcon from 'assets/dashboard/tds.png';
import TdsConfigDashboard from './tdsConfigs';
import TdsDashboard from './tdsOffers';

export const TDS_RESOURCES = {
	tdsOffers: 'tdsOffers',
	tdsConfigs: 'tdsConfigs'
};

export const URL = {
	[TDS_RESOURCES.tdsOffers]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/tds/${TDS_RESOURCES.tdsOffers}`,
	[TDS_RESOURCES.tdsConfigs]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/tds/${TDS_RESOURCES.tdsConfigs}`
};

export const LABEL = {
	[TDS_RESOURCES.tdsOffers]: 'TDS Offers',
	[TDS_RESOURCES.tdsConfigs]: 'TDS Configs'
};

export const COMPONENT = {
	[TDS_RESOURCES.tdsOffers]: TdsDashboard,
	[TDS_RESOURCES.tdsConfigs]: TdsConfigDashboard
};

export const GET_ACTION = {
	[TDS_RESOURCES.tdsOffers]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getTDSActiveOffers,
	[TDS_RESOURCES.tdsConfigs]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getTDSConfigs
};

export const IMAGE_SOURCE = {
	[TDS_RESOURCES.tdsOffers]: tdsIcon,
	[TDS_RESOURCES.tdsConfigs]: tdsIcon
};

export type Record = {
	[key: string]: string | number | boolean;
};

export type SelectedUserType = {
	email: string;
	uid: string;
	phone: string;
	userSegment: string;
	addToStatic: boolean;
};

export const ADD_OFFER_ENDPOINT = '/dashboard/finance/tds/tdsOffers/create';
export const EDIT_OFFER_ENDPOINT = '/dashboard/finance/tds/tdsOffers/edit';
export const BACK_OFFER_ENDPOINT = '/dashboard/finance/tds/tdsOffers/list';
export const DETAILS_OFFER_ENDPOINT = '/dashboard/finance/tds/tdsOffers/tdsOfferDetails';
export const CLONE_OFFER_ENDPOINT = '/dashboard/finance/tds/tdsOffers/clone';
export const CREATE_OFFER_URI = '/marketing/dashboard/finance/createTDSOffers';
export const UPDATE_OFFER_URI = '/marketing/dashboard/finance/updateTDSOffers';
export const DISABLE_OFFER_URI = '/marketing/dashboard/finance/disableTDSOffers';
export const GET_OFFER_URI = '/marketing/dashboard/finance/getTDSActiveOffers';
export const ADD_CONFIG_ENDPOINT = '/dashboard/finance/tds/tdsConfigs/create';
export const EDIT_CONFIG_ENDPOINT = '/dashboard/finance/tds/tdsConfigs/edit';
export const BACK_CONFIG_ENDPOINT = '/dashboard/finance/tds/tdsConfigs/list';
export const DETAILS_CONFIG_ENDPOINT = '/dashboard/finance/tds/tdsConfigs/tdsOfferDetails';
export const CLONE_CONFIG_ENDPOINT = '/dashboard/finance/tds/tdsConfigs/clone';
export const CREATE_CONFIG_URI = '/marketing/dashboard/finance/createTDSConfigs';
export const UPDATE_CONFIG_URI = '/marketing/dashboard/finance/updateTDSConfigs';
export const DISABLE_CONFIG_URI = '/marketing/dashboard/finance/removeTDSConfigs';
export const GET_CONFIG_URI = '/marketing/dashboard/finance/getTDSConfigs';

export const EN_LOCAL_DATA = 'en-IN';
